import { render } from "./Commercial.vue?vue&type=template&id=b7e875da&scoped=true"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"

import "./Commercial.vue?vue&type=style&index=0&id=b7e875da&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e875da"]])

export default __exports__